import { action } from 'easy-peasy';
import { ISetShelterAction } from '../types';

const setShelter: ISetShelterAction = action((state, payload) => {
  state.current = payload;
});

export default setShelter;
